module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "topic"
    }
  }, [(_vm.showCutscenes) ? _c('Cutscenes') : _vm._e(), _vm._v(" "), _c('DownloadNav', {
    attrs: {
      "ifShow": _vm.ifShow
    }
  }), _vm._v(" "), (_vm.tag_info) ? [_c('img', {
    staticClass: "banner",
    attrs: {
      "src": _vm.tag_info.tag_img_square,
      "alt": "",
      "srcset": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "top_pic"
  }, [(_vm.tag_info) ? _c('div', {
    class: ("topic_content " + (_vm.topicMode != 0 ? 'special' : 'normal'))
  }, [_c('div', {
    staticClass: "topic_name"
  }, [_c('span', {
    staticClass: "icon"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.tag_info.tag_name))])]), _vm._v(" "), (_vm.topicMode == 0) ? _c('p', {
    staticClass: "topic_detail"
  }, [_vm._v("\n          " + _vm._s(_vm.tag_info.tag_desc) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "topic_comments"
  }, [_vm._v("讨论 " + _vm._s(_vm.tag_info.thread_count))])]) : _vm._e()]), _vm._v(" "), (_vm.activity.tag_desc) ? _c('a', {
    staticClass: "topic_link",
    attrs: {
      "href": _vm.activity.url || 'javascript:;'
    }
  }, [_c('span', {
    staticClass: "txt"
  }, [_vm._v(_vm._s(_vm.activity.tag_desc))]), _vm._v(" "), _c('i', {
    staticClass: "arrow"
  })]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.topicMode != 0) ? _c('div', {
    staticClass: "prize-mode"
  }, [_c('div', {
    staticClass: "topic_desc"
  }, [_c('span', [_vm._v("\n        " + _vm._s(_vm.tag_info ? _vm.tag_info.tag_desc : '') + "\n      ")]), _vm._v(" "), _c('span', [(_vm.topicMode != 0) ? _c('a', {
    staticClass: "detail_btn",
    attrs: {
      "href": _vm.tag_info.prize_info ? _vm.tag_info.prize_info.url : ''
    }
  }, [_vm._v("查看详情>>>")]) : _vm._e()])]), _vm._v(" "), (_vm.tag_info && _vm.tag_info.end_at != 0 && _vm.activityEndTime) ? _c('div', {
    staticClass: "count-down"
  }, [_c('span', {
    staticClass: "line"
  }), _vm._v(" "), (!_vm.activityEndTime.isEnd) ? _c('span', {
    staticClass: "txt"
  }, [_vm._v("剩余时间：" + _vm._s(_vm.activityEndTime.d) + "天 " + _vm._s(_vm.activityEndTime.h) + "时 " + _vm._s(_vm.activityEndTime.m) + "分 " + _vm._s(_vm.activityEndTime.s) + "秒")]) : _c('span', {
    staticClass: "txt"
  }, [_vm._v("活动已结束")]), _vm._v(" "), _c('span', {
    staticClass: "line"
  })]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "jump-link"
  })]) : _vm._e(), _vm._v(" "), (_vm.tabsConfig.tabs.length) ? _c('tab-nav', {
    ref: "tabNav",
    attrs: {
      "tabs": _vm.tabsConfig.tabs,
      "active": _vm.tabsConfig.active
    },
    on: {
      "change": _vm.tabChanged
    }
  }) : _vm._e(), _vm._v(" "), (_vm.labels.length) ? _c('div', {
    ref: "labelContainer",
    staticClass: "label-list"
  }, _vm._l((_vm.labels), function(item, index) {
    return _c('span', {
      key: ("label_" + index),
      class: ("label " + (index == _vm.currIndex ? 'active' : '')),
      attrs: {
        "data-index": index,
        "data-lid": item.label_id
      },
      on: {
        "click": _vm.tabLabel
      }
    }, [_vm._v("\n      " + _vm._s(item.label_name) + "\n    ")])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.listMode == 0 && _vm.normalList.length) ? _c('div', {
    class: ("tab_content " + (_vm.prizes.length && _vm.tabsConfig.tabs[_vm.tabsConfig.active] == '排行'? '' : 'gray'))
  }, _vm._l((_vm.normalList), function(poData, po_item_index) {
    return _c('div', {
      key: po_item_index,
      staticClass: "po_item"
    }, [(_vm.prizes.length > 0 && (po_item_index < _vm.prizes.length) && _vm.tabsConfig.tabs[_vm.tabsConfig.active] == '排行') ? _c('div', {
      class: ("prize_tag " + (po_item_index > 2 ? 'pink' : ''))
    }, [_c('div', {
      staticClass: "crown"
    }), _vm._v(" "), _c('div', {
      staticClass: "txt"
    }, [_vm._v("\n          " + _vm._s(_vm.prizes[po_item_index]) + "\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
      class: ("po_top " + (_vm.prizes.length && po_item_index < _vm.prizes.length && _vm.tabsConfig.tabs[_vm.tabsConfig.active] == '排行' ? '' : 'margin'))
    }, [_c('div', {
      staticClass: "user_info"
    }, [_c('div', {
      staticClass: "avatar",
      style: ('background-image:url(' + poData.user.face + ')')
    }), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_c('p', {
      class: 'user_name sex_' + poData.user.gender
    }, [_vm._v(_vm._s(poData.user.username))]), _vm._v(" "), _c('p', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm._f("timestamp2txt")(poData.dateline)))])])]), _vm._v(" "), _c('div', {
      staticClass: "stamp",
      style: ('background-image:url(' + poData.tag_stick + ')')
    })]), _vm._v(" "), _c('div', {
      staticClass: "po_content"
    }, [_c('div', {
      staticClass: "po_txt",
      on: {
        "click": function($event) {
          return _vm.jumpPoDetail(poData.id)
        }
      }
    }, [(_vm.tag_info) ? _c('span', {
      staticClass: "tag"
    }, [_vm._v(_vm._s('#' + _vm.tag_info.tag_name))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "poContent",
      domProps: {
        "innerHTML": _vm._s(_vm.contentFilters(poData.content))
      }
    })]), _vm._v(" "), _c('PicBox', {
      attrs: {
        "images": poData.images,
        "type": poData.type
      }
    }), _vm._v(" "), (poData.address) ? _c('div', {
      staticClass: "location",
      on: {
        "click": function($event) {
          return _vm.jumpLocation(poData.extra.position_x, poData.extra.position_y)
        }
      }
    }, [_vm._v(_vm._s(poData.address))]) : _vm._e()], 1), _vm._v(" "), (poData.labels.length) ? _c('div', {
      staticClass: "po-labels-list"
    }, [_c('span', {
      staticClass: "label-icon"
    }), _vm._v(" "), _vm._l((poData.labels), function(lItem, lIndex) {
      return _c('span', {
        key: ((poData.id) + "_" + lIndex),
        staticClass: "po-label",
        on: {
          "click": function($event) {
            return _vm.toLabel(lItem.label_id)
          }
        }
      }, [_vm._v("\n          " + _vm._s(lItem.label_name) + "\n        ")])
    })], 2) : _vm._e(), _vm._v(" "), (poData.praise_count > 0) ? _c('div', {
      staticClass: "zan_wrap",
      on: {
        "click": function($event) {
          return _vm.jumpPoDetail(poData.id)
        }
      }
    }, [_c('div', {
      staticClass: "avatar_list"
    }, [_vm._l((poData.praise), function(item, index) {
      return (index < 9) ? _c('div', {
        key: index,
        staticClass: "avatar",
        style: ('background-image:url(' + item.face + ')')
      }) : _vm._e()
    }), _vm._v(" "), _c('div', {
      staticClass: "zan_count"
    }, [_vm._v(_vm._s(poData.praise_count <
      100 ? poData.praise_count + '赞' : '99+'))])], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "comment_list",
      on: {
        "click": function($event) {
          return _vm.jumpPoDetail(poData.id)
        }
      }
    }, [_vm._l((poData.comments), function(item, index) {
      return (index < 3) ? _c('div', {
        key: index,
        staticClass: "item"
      }, [_c('span', {
        class: 'user sex_' + item.cuinfo.gender
      }, [_vm._v(_vm._s(item.cuinfo.username))]), _vm._v(" "), (item.ruinfo.username) ? [_c('span', {
        staticClass: "to"
      }, [_vm._v("回复")]), _vm._v(" "), _c('span', {
        class: 'user sex_' + item.ruinfo.gender
      }, [_vm._v(_vm._s(item.ruinfo.username))])] : _vm._e(), _vm._v(" "), _c('span', [_vm._v("：")]), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(item.comment)
        }
      })], 2) : _vm._e()
    }), _vm._v(" "), (poData.comment_count > 3) ? _c('div', {
      staticClass: "more"
    }, [_vm._v("\n                查看全部(" + _vm._s(poData.comment_count) + ")\n              ")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "po_item_ctrl"
    }, [_c('div', {
      staticClass: "input_wrap",
      on: {
        "click": _vm.openAppTopic
      }
    }, [_vm._v("回复 " + _vm._s(poData.username))]), _vm._v(" "), _c('i', {
      staticClass: "share",
      on: {
        "click": _vm.openAppTopic
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "zan",
      class: poData.is_praise ? 'on' : '',
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.onZan(po_item_index)
        }
      }
    })])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.listMode == 1) ? _c('div', {
    staticClass: "tab_content"
  }, [_c('div', {
    staticClass: "water_fall"
  }, [_c('div', {
    staticClass: "col_wrap"
  }, [_c('div', {
    ref: "col_0"
  }, _vm._l((_vm.waterFall.col_0), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.jumpPoDetail(item.id)
        }
      }
    }, [(item.views != 0) ? _c('div', {
      staticClass: "read_count"
    }, [_vm._v(_vm._s(item.views))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "img",
      style: (("background-image:url(" + (item.cover.url) + ");height:" + (item.cover.h) + "px;width:" + (item.cover.w) + "px;"))
    }, [(item.type == 2) ? _c('div', {
      staticClass: "mask"
    }, [_c('div', {
      staticClass: "video-btn"
    })]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "desc",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "user_n_time"
    }, [_c('div', {
      staticClass: "user-info"
    }, [_c('img', {
      staticClass: "user_avatar",
      attrs: {
        "src": item.user.face,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      class: 'username sex_' + item.user.gender
    }, [_vm._v(_vm._s(item.user.username))])]), _vm._v(" "), (item.praise_count != 0) ? _c('div', {
      staticClass: "praise-content"
    }, [_c('span', {
      staticClass: "praise-icon"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.praise_count))])]) : _vm._e()])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col_wrap"
  }, [_c('div', {
    ref: "col_1"
  }, _vm._l((_vm.waterFall.col_1), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.jumpPoDetail(item.id)
        }
      }
    }, [(item.views != 0) ? _c('div', {
      staticClass: "read_count"
    }, [_vm._v(_vm._s(item.views))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "img",
      style: (("background-image:url(" + (item.cover.url) + ");height:" + (item.cover.h) + "px;width:" + (item.cover.w) + "px;"))
    }, [(item.type == 2) ? _c('div', {
      staticClass: "mask"
    }, [_c('div', {
      staticClass: "video-btn"
    })]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "desc",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "user_n_time"
    }, [_c('div', {
      staticClass: "user-info"
    }, [_c('img', {
      staticClass: "user_avatar",
      attrs: {
        "src": item.user.face,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      class: 'username sex_' + item.user.gender
    }, [_vm._v(_vm._s(item.user.username))])]), _vm._v(" "), (item.praise_count != 0) ? _c('div', {
      staticClass: "praise-content"
    }, [_c('span', {
      staticClass: "praise-icon"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.praise_count))])]) : _vm._e()])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.tabsConfig.active == 1) ? _c('div') : _vm._e(), _vm._v(" "), _c('BottomLoading', {
    style: (_vm.ifShowBottomLoading ? 'visibility:visible' : 'visibility:hidden')
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-5ded73a2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/newTopic/Topic.vue
// module id = 119
// module chunks = 1